async function jsonFetch(url, opts = {}) {
  const res = await fetch(url, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(opts.headers || {}) },
    ...opts,
  })

  const text = await res.text()
  let data = null
  try {
    data = text ? JSON.parse(text) : null
  } catch {
    data = text
  }

  if (!res.ok) {
    const msg = (data && (data.error || data.message)) || `HTTP ${res.status}`
    throw new Error(msg)
  }
  return data
}

export async function listMonoConnections({ tenant_id, limit = 20 } = {}) {
  const qs = new URLSearchParams()
  if (tenant_id != null) qs.set('tenant_id', String(tenant_id))
  if (limit != null) qs.set('limit', String(limit))
  return jsonFetch(`/api/mono/connections?${qs.toString()}`, { method: 'GET' })
}

export async function initiateMono({ tenant_id, name, email } = {}) {
  return jsonFetch(`/api/mono/accounts/initiate`, {
    method: 'POST',
    body: JSON.stringify({ tenant_id, name, email }),
  })
}
